import React from 'react';
import cn from 'classnames';

const DownloadButton = ({ className, url, ...props }) => {
  const btnClassName = cn(
    'k-button k-icon-button k-button-md k-button-rectangle k-button-solid k-button-solid-base k-rounded-md',
    { [className]: className },
  );
  return (
    <a className={btnClassName} href={url} data-testid={props.id} {...props}>
      <span className='k-icon k-i-download' />
    </a>
  );
};

DownloadButton.displayName = 'DownloadButton';

export default DownloadButton;
